var React = require('react');

function Collection (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"\n    svg.download.icon .no-fill { fill: none; }\n  "),React.createElement("path",{"className":"primary-fill","d":"M0,0H9.217V9.217H0ZM0,20.481H9.217V11.265H0Zm11.265,0h9.217V11.265H11.265ZM16.385,4.1V0H15.361V4.1h-4.1V5.12h4.1v4.1h1.024V5.12h4.1V4.1Z","key":1})]);
}

Collection.defaultProps = {"className":"collection icon","viewBox":"0 0 20.481 20.481"};

module.exports = Collection;

Collection.default = Collection;
